import { render } from "./StdTable.vue?vue&type=template&id=b7a30f7e"
import script from "./StdTable.vue?vue&type=script&lang=js"
export * from "./StdTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__